export const negativeNumberMask = {
  mask: Number,
  signed: true,
  thousandsSeparator: ' ',
  radix: '.',
};
